// Preserves the MCP authorise URL across login flows that leave the SPA.
//
// The /login?redirect_url=... query param survives email/password sign-in,
// but Google OAuth and email-confirmation round trips return via Supabase,
// which only honours redirectTo URLs on its dashboard allowlist — query
// params fail glob matching and the user gets bounced to the Site URL,
// losing the authorise screen. localStorage survives that bounce (and a
// confirmation link opening a new tab), so the journey can resume.

const STORAGE_KEY = "cp:pending-auth-redirect";
const TTL_MS = 30 * 60 * 1000; // MCP clients' PKCE state is short-lived anyway

function toSameOriginPath(url) {
  try {
    const target = new URL(url, window.location.origin);
    if (target.origin !== window.location.origin) return null;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return null;
  }
}

export function storePendingAuthRedirect(url) {
  const path = toSameOriginPath(url);
  if (!path) return;
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ url: path, expiresAt: Date.now() + TTL_MS })
    );
  } catch {
    // Storage unavailable (private mode/quota) — the redirect_url query
    // param still covers same-page login flows.
  }
}

export function consumePendingAuthRedirect() {
  let raw;
  try {
    raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }
  try {
    const { url, expiresAt } = JSON.parse(raw);
    if (typeof url !== "string" || typeof expiresAt !== "number") return null;
    if (Date.now() > expiresAt) return null;
    return toSameOriginPath(url);
  } catch {
    return null;
  }
}
